import type { MinimumVersionDto } from '@relay-towing/api';
import type { NativePlatform } from './nativeBridge';

/**
 * "2.4.0" against "2.10.1", part by part as numbers: as strings, 2.10 sorts
 * before 2.4 and a current build would be told to update. A missing part is
 * 0, and anything after a part's digits ("1-beta") is ignored.
 */
export function compareVersions(a: string, b: string): number {
  const parts = (version: string) =>
    version.split('.').map((part) => parseInt(part, 10) || 0);
  const left = parts(a);
  const right = parts(b);
  for (let i = 0; i < Math.max(left.length, right.length); i += 1) {
    const difference = (left[i] ?? 0) - (right[i] ?? 0);
    if (difference !== 0) return Math.sign(difference);
  }
  return 0;
}

/**
 * Whether this build is older than the server allows for its platform. No
 * minimum for the platform means every build is allowed.
 */
export function isBelowMinimum(
  platform: NativePlatform,
  appVersion: string,
  minimum: MinimumVersionDto
): boolean {
  const required = minimum[platform];
  return !!required && compareVersions(appVersion, required) < 0;
}
